<template>
  <HomePage />
</template>

<script setup lang="ts">
import { homepageHead } from '~/data/seo'

useHead(homepageHead())
</script>
